/* src/app/components/SimpleTable/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
} from '@material-ui/core';

import styles from './styles';

const SimpleTable = props => {
  const {
    classes,
    data,
    Footer,
    onRowClick,
    hover,
    header,
    gutterBottom,
    footerStyle,
  } = props;

  return (
    <Table className={classNames({ [classes.gutter]: gutterBottom })}>
      {header && (
        <TableHead>
          <TableRow className={classes.header}>
            <TableCell>{header}</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
      )}
      <TableBody>
        {data.map(({ title, value }, i) => (
          <TableRow key={i} hover={hover} onClick={() => onRowClick(i)}>
            <TableCell>{title}</TableCell>
            <TableCell numeric>{value}</TableCell>
          </TableRow>
        ))}
      </TableBody>
      {Footer && (
        <TableFooter>
          <TableRow>
            <TableCell />
            <TableCell classes={{ footer: footerStyle }}>{Footer}</TableCell>
          </TableRow>
        </TableFooter>
      )}
    </Table>
  );
};

SimpleTable.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  Footer: PropTypes.node,
  onRowClick: PropTypes.func,
  hover: PropTypes.bool,
  gutterBottom: PropTypes.bool,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  footerStyle: PropTypes.string,
};

SimpleTable.defaultProps = {
  Footer: null,
  onRowClick: () => {},
  hover: false,
  gutterBottom: false,
  header: null,
  footerStyle: '',
};

export default withStyles(styles)(SimpleTable);



// WEBPACK FOOTER //
// ./src/app/components/SimpleTable/index.js